// src/LineChartComponent.js
import React from 'react';
import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer} from 'recharts';

const LineChartComponent = ({ data }) => {
  return (
      <ResponsiveContainer width="100%" height={600}>
    <LineChart data={data}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="time" />
      <YAxis yAxisId="left" label={{ value: "file actions", angle: -90, stroke: "#e6e212", position: 'insideLeft' }} />
        <YAxis yAxisId="right" orientation="right" label={{ value:"alerts", angle: -90, stroke: "#de3309", position: 'insideRight' }} />
      <Tooltip />
      <Legend />
      <Line yAxisId="left" type="monotone" dataKey="creates" stroke="#04c44e" />
        <Line yAxisId="left" type="monotone" dataKey="reads" stroke="#e6e212" />
        <Line yAxisId="left" type="monotone" dataKey="updates" stroke="#443dd9" />
        <Line yAxisId="left" type="monotone" dataKey="deletes" stroke="#f7b934" />
      <Line yAxisId="right" type="monotone" dataKey="alerts" stroke="#de3309" />
    </LineChart>
      </ResponsiveContainer>
  );
};

export default LineChartComponent;
